import { LOADING_BAR_ID } from '../loadingSplash'

// Full-screen black backdrop shown while the scene loads. Stays mounted so it can
// fade out once `ready` (instead of vanishing a frame later); it keeps blocking
// pointer events until then so the early interactables stay inert.
export default function LoadingSplash({ ready }: { ready: boolean }) {
  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'black', zIndex: 10,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        opacity: ready ? 0 : 1, transition: 'opacity 1.5s ease',
        pointerEvents: ready ? 'none' : 'auto',
      }}
    >
      <h1 className="loading-splash-title">Witamy w wirtualnym Muzeum Aleksandra Fredry</h1>
      {/* Classic left-to-right progress bar. The fill's width is driven imperatively
          via window.setLoadingProgress (see loadingSplash.ts) — not React state — so
          the App tree never re-renders mid-load and clobbers it. */}
      <div className="loading-splash-track">
        <div id={LOADING_BAR_ID} className="loading-splash-bar" />
      </div>
      <p className="loading-splash-footer">Wszelkie prawa zastrzeżone © 2026 - Fundacja Rodu Szeptyckich</p>
    </div>
  )
}
